<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="orderType"
          :dropdown-match-select-width="false"
          selectType="selectMultiple"
          v-model="queryParams.orderType"
          requestApi="/inv/invOnhandQuantities/findAsnOrderTypeList"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          sourseField="res"
        />
        <global-select
          v-decorator="['orgCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="orgCode"
          :value.sync="queryParams.orgCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          slot="alternativeMaterialList"
          searchParam="alternativeMaterialList"
          selectType="selectSearch"
          :dropdown-match-select-width="false"
          v-model="queryParams.alternativeMaterialList"
          requestApi="/inv/invOnhandQuantities/alternativeMaterialListBox"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvOnhandQuantitiesExport" ref="download" />
        <a-button
          type="primary"
          @click="handleExport"
        >导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.INVENTORY_DETAILS_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiGetInventoryDetailsList,
  apiInvOnhandQuantitiesExport
} from '@/api/report/inventory-outbound-details'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Inventory-details', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      apiInvOnhandQuantitiesExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInventoryDetailsList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        orgCode: undefined,
        sublibraryCode: undefined,
        orderType: undefined,
        itemCode: undefined,
        supplierCode: undefined,
        lotName: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '工单号',
          decorator: ['wipEntityNameVal'],
          type: 'input'
        },
        {
          label: '组织编码',
          decorator: ['orgCode'],
          type: 'orgCode'
        },
        {
          label: '子库代码',
          decorator: ['sublibraryCode'],
          type: 'input'
        },
        {
          label: '单据类型',
          decorator: ['orderType'],
          type: 'orderType'
        },
        {
          label: '物料编码',
          decorator: ['itemCode'],
          type: 'input'
        },
        {
          label: '供应商编码',
          decorator: ['supplierCode'],
          type: 'input'
        },
        {
          label: '生产批次',
          decorator: ['lotName'],
          type: 'input'
        },
        {
          label: '收货日期',
          type: 'range',
          decorator: ['deliveryDate'],
          disposeFormat: {
            deliveryDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            deliveryDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '交货日期',
          type: 'range',
          decorator: ['jhDate'],
          disposeFormat: {
             jhDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
             jhDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '收货单',
          type: 'input',
          decorator: ['receiptNumer']
        },
        {
          label: '外部单号',
          type: 'input',
          decorator: ['orderNumber']
        },
        {
          label: '外部单号2',
          type: 'input',
          decorator: ['orderNumber2']
        },
        {
          label: '签价单号',
          type: 'alternativeMaterialList',
          decorator: ['alternativeMaterialList']
        }
      ],
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '库位',
          dataIndex: 'lockey',
          align: 'center',
          width: 120
        },
        {
          title: '组织编码',
          dataIndex: 'orgCode',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '收货时间',
          dataIndex: 'receiptsDate',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库名称',
          dataIndex: 'sublibrary',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '子库代码',
          dataIndex: 'sublibraryCode',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '收货单',
          dataIndex: 'receiptNumer',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '外部单号',
          dataIndex: 'orderNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '外部单号2',
          dataIndex: 'orderNumber2',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '签价单号',
          dataIndex: 'alternativeMaterialList',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单据类型',
          dataIndex: 'orderType',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单据行号',
          dataIndex: 'lineNum',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '货品分类',
          dataIndex: 'goodsType',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '预收货量',
          dataIndex: 'preReceivedQty',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '实收数量',
          dataIndex: 'receiptsQty',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '实收数量',
          dataIndex: 'receiptsQty',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '质检状态',
          dataIndex: 'zjStatus',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商编码',
          dataIndex: 'supplierCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '生产批次',
          dataIndex: 'lotName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '质检',
          dataIndex: 'lotLevel',
          align: 'center',
          width: 150
        },
        {
          title: '操作人员',
          dataIndex: 'createName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '源子库',
          dataIndex: 'sourceSublibraryCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '交货日期',
          dataIndex: 'jhDate',
          scopedSlots: { customRender: 'dateFormat' },
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created() {
    // 处理缓存逻辑
    this.getHistoryCache(
      'refSearchForm',
      'orgCode',
      {
        deliveryDate: ['deliveryDateFrom', 'deliveryDateTo'],
        jhDate: ['jhDateFrom', 'jhDateTo']
      }
    )
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(params, valField, listField) {
      const listVal = []
      if (params[valField]) {
        const list = params[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      params[listField] = listVal
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      this.onChangeCopyFormExcel(params, 'wipEntityNameVal', 'wipEntityNameList')
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        orgCode: this.$refs.dataTable.searchParams.orgCode,
        sublibraryCode: undefined,
        orderType: undefined,
        itemCode: undefined,
        supplierCode: undefined,
        lotName: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 搜索框展开、收起
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
